exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._XDxEE{position:absolute;font-family:Helvetica Neue,Helvetica,Arial,\"sans-serif\";font-size:14px;line-height:20px;z-index:350;border:1px solid #000;background-color:#faf7aa;padding:4px;border-radius:4px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"hint": "_XDxEE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=_[hash:base64:5]!./~/postcss-loader!./~/autoprefixer-loader!./~/less-loader!./lib/Hint.less
// module id = 14
// module chunks = 0